// extracted by mini-css-extract-plugin
export default {"container":"OrganisationUserHeader_container__Hof-6","controls":"OrganisationUserHeader_controls__wNYfm"};